import React from "react";

import { useTranslation } from "react-i18next";

const RemoteWorkPreview = ({ interview }) => {
  const { t } = useTranslation();
  const { remoteWork } = interview.availabilityAndConditions;

  return (
    <div className="remote-work-options">
      <h1>{t("Remote work")}</h1>
      <div className="selected-areas">
        {remoteWork.length > 0 ? (
          remoteWork.map((item) => <div className="areas">{item}</div>)
        ) : (
          <div>
            {t("There are no remote work options selected for this interview")}
          </div>
        )}
      </div>
    </div>
  );
};

export default RemoteWorkPreview;
